<template>
  <div style="padding: 20px">
    <pagination-table
      :data="revertTurbineTypeList"
      :columns="columns"
      :loader="getTurbineTypeList"
      :async="true"
      :pageSizes="[20]"
      :colCustom="colCustom"
    ></pagination-table>
  </div>
</template>
<script>
export default {
  data() {
    return {
      turbineTypeList: [],
      columns: [
        {
          label: '序号',
          width: '60',
          render: (h, scope) => {
            const element = scope.$index + 1;
            return <div>{element}</div>;
          }
        },
        {
          prop: 'typeName',
          label: '机型',
          width: '200'
        },
        {
          // prop: 'stateAppName',
          label: '是否计算利用小时数默认机型(APP)',
          width: '280',
          render: (h, scope) => {
            const element =
              scope.row.stateAppName === '是' ? (
                <i
                  class="el-icon-success"
                  style={{ color: 'green', fontSize: '18px' }}
                ></i>
              ) : (
                <i
                  class="el-icon-error"
                  style={{ color: 'red', fontSize: '18px' }}
                ></i>
              );
            return <div>{element}</div>;
          }
        },
        {
          // prop: 'statePcName',
          label: '是否计算利用小时数默认机型(PC)',
          width: '280',
          render: (h, scope) => {
            const element =
              scope.row.statePcName === '是' ? (
                <i
                  class="el-icon-success"
                  style={{ color: 'green', fontSize: '18px' }}
                ></i>
              ) : (
                <i
                  class="el-icon-error"
                  style={{ color: 'red', fontSize: '18px' }}
                ></i>
              );
            return <div>{element}</div>;
          }
        },
        {
          label: 'APP',
          render: (h, scope) => {
            //console.log('row', scope);
            const element =
              scope.row.stateApp === 0 ? (
                <el-button
                  size="mini"
                  onClick={() => this.setAndResetDefaultAPP(scope.row, 'set')}
                >
                  设为默认
                </el-button>
              ) : (
                <el-button
                  size="mini"
                  onClick={() => this.setAndResetDefaultAPP(scope.row, 'reset')}
                  v-else
                >
                  取消默认
                </el-button>
              );
            return <div>{element}</div>;
          }
        },
        {
          label: 'PC',
          render: (h, scope) => {
            //console.log('row', scope);
            const element =
              scope.row.statePc === 0 ? (
                <el-button
                  size="mini"
                  onClick={() => this.setDefaultPC(scope.row, 'set')}
                >
                  设为默认
                </el-button>
              ) : (
                <el-button
                  size="mini"
                  onClick={() => this.setDefaultPC(scope.row, 'reset')}
                  v-else
                >
                  取消默认
                </el-button>
              );
            return <div>{element}</div>;
          }
        }
      ]
    };
  },
  computed: {
    revertTurbineTypeList() {
      return this.turbineTypeList.map(item => {
        item.stateAppName = item.stateApp === 1 ? '是' : '否';
        item.statePcName = item.statePc === 1 ? '是' : '否';
        return item;
      });
    }
  },
  async mounted() {
    await this.getTurbineTypeList({ page: 0 });
  },
  methods: {
    async getTurbineTypeList(options) {
      const { data } = await this.$fetch('/manage/station/getTurbineTypeList', {
        module: 'manage',
        params: { pageNo: options.page }
      });
      this.turbineTypeList = data.defaultParam.rows;
      return {
        data: data.defaultParam && data.defaultParam.rows,
        total: data.defaultParam && data.defaultParam.total
      };
    },
    async setAndResetDefaultAPP(row, type) {
      const stateApp = type === 'set' ? 1 : 0;
      await this.$postForm({
        url: '/manage/station/saveTurbineTypeState',
        module: 'manage',
        data: {
          turbineTypeId: row.turbineTypeId,
          stateApp,
          statePc: row.statePc || 0
        },
        showLoading: true,
        showError: true,
        showSuccess: true
      });
      await this.getTurbineTypeList({ page: 0 });
    },
    async setDefaultPC(row, type) {
      const statePc = type === 'set' ? 1 : 0;
      await this.$postForm({
        url: '/manage/station/saveTurbineTypeState',
        module: 'manage',
        data: {
          turbineTypeId: row.turbineTypeId,
          stateApp: row.stateApp || 0,
          statePc
        },
        showLoading: true,
        showError: true,
        showSuccess: true
      });
      await this.getTurbineTypeList({ page: 0 });
    }
  }
};
</script>
<style lang="less" scoped></style>
